export default {
  title: 'Satıcı Arkadaşınızı Önerin, Önerdikçe Kazanın!',
  subtitle: 'Kampanya şehirlerindeki satıcı arkadaşlarınızı önerin, arkadaşlarınız satışa başlasın ve siz de getirdiğiniz her arkadaşınız için avantajlardan yararlanın!',
  advantages: {
    oneNewSeller: '1 Yeni Satıcıya<br>250 TL Reklam Bakiyesi!',
    threeNewSellers: '3 Yeni Satıcıya<br>%15 Komisyon İndirimi!',
    fiveNewSellers: '5 Yeni Satıcıya<br>%20 Komisyon İndirimi!',
    tenNewSellers: '10 Yeni Satıcıya<br>%30 Komisyon İndirimi!',
  },
  form: {
    title: 'Satıcı Öneri Formu',
    subtitle: 'Siz de hemen aşağıdaki satıcı öneri formunu doldurun, önerdiğiniz satıcı adayıyla iletişime geçelim!',
    sellerName: 'ÖNERDİĞİNİZ FİRMANIN ADI',
    contactName: 'ÖNERDİĞİNİZ FİRMA YETKİLİSİNİN ADI',
    contactSurname: 'ÖNERDİĞİNİZ FİRMA YETKİLİSİNİN SOYADI',
    contactPhone: 'ÖNERDİĞİNİZ FİRMA YETKİLİSİNİN CEP TELEFONU NO’SU',
    contactEmail: 'ÖNERDİĞİNİZ FİRMA YETKİLİSİNİN E-MAİL ADRESİ',
    isTaxPayer: 'ÖNERDİĞİNİZ SATICI VERGİ MÜKELLEFİ Mİ?',
    yes: 'Evet',
    no: 'Hayır',
    obligationTextInforms: 'Kişisel verilerimin işlenmesine yönelik <a class="text-link" href="https://tymp.mncdn.com/prod/documents/satici-oneri-kvkk-aydinlatma-metni.pdf" target="_blank">aydınlatma metnini</a> okudum ve anladım.',
    sellerRecommendationObligationTextInforms: 'Satıcı Öner sistemi vasıtasıyla kimlik bilgilerini ve iletişim bilgilerini paylaştığım satıcıyla iletişime geçilebileceğini, önerdiğim satıcının bu konuda bilgilendirdiğimi ve onayını aldığımı taahhüt ederim.',
    send: 'GÖNDER',
    errors: {
      sellerName: 'Firma Adı',
      contactName: 'Yetkili Adı',
      contactSurname: 'Yetkili Soyadı',
      contactPhone: 'Telefon Numarası',
      contactEmail: 'E-mail',
    },
  },
  campaignInfo: {
    title: 'Trendyol olarak Türkiye\'nin tüm şehirlerinde KOBİlerimizin dijitaleşmesini destekliyoruz. Siz de kampanya şehirlerindeki satıcı arkadaşlarınıza Trendyol\'dan satıcı olmaktan bahsedin, izinleri dahilinde aşağıdaki formdan bilgilerini paylaşıp kampanyaya katılın. Arkadaşlarınızın işlerini dijitalleştirmelerine yardımcı olurken, siz de önerdiğiniz arkdaşlarınız için toplamda 1 ay süreyle %30\'a varan komisyon indirimi kazanın.',
    campaignTerms: {
      title: 'Kampanya Koşulları',
      one: 'Kampanya 21 Ekim - 30 Kasım arasında önerdiğiniz arkadaşlarınız için geçerlidir.',
      two: 'Dilediğiniz kadar arkadaşınızı önerebilirsiniz.',
      three: 'Önereceğiniz arkadaşlarınızın bağlı olduğu vergi dairesi kampanya şehirlerinde olmalıdır. Diğer şehirlerden önerilen satıcılar kampanyaya dahil edilmeyecektir. Kampanyaya dahil olan şehirlere <a class="city-list-link" href="https://tymp.mncdn.com/prod/documents/arkadasini-getir-kampanya-sehirler.pdf" target="_blank">buraya</a> tıklayarak ulaşabilirsiniz.',
      four: 'Form doldurulmadan önce arkadaşlarınıza kampanyadan bahsedip onayı dahilinde bilgilerinin paylaşılması gerekmektedir.',
      five: 'Form doldurulduktan sonra arkadaşlarınızı arayacağız, kampanya koşullarını uygun olması ya da olmaması durumunda sizi bilgilendireceğiz.',
      six: 'Kampanyadan faydalanabilmek için önerilen satıcıların 21 Ekim - 30 Kasım tarihleri arasında satışa başlayıp en az 5 sipariş alması gerekmektedir.',
      seven: 'Koşulları sağlayan;<br><br>' +
        '<span class="bold-text">1 yeni satıcı</span> arkadaşınızın için <span class="bold-text">250 TL Reklam Bakiyesi</span>,<br>' +
        '<span class="bold-text">3 yeni satıcı</span> arkadaşınız için 1 ay süreyle <span class="bold-text">%15 komisyon indirimi,</span><br>' +
        '<span class="bold-text">5 yeni satıcı</span> arkadaşınız için 1 ay süreyle <span class="bold-text">%20 komisyon indirimi,</span><br>' +
        '<span class="bold-text">10 ve daha fazla yeni satıcı</span> arkadaşınız için 1 ay süreyle <span class="bold-text">%30 komisyon indirimi,</span> <br><br>' +
        '2021 Aralık ayının ilk haftasında hesabınıza tanımlanacaktır.',
    },
  },
  modal: {
    title: 'Başvurunuz İletildi!',
    description: 'Kobilerin dijitalleşmesi için attığınız adım için teşekkürler! Kampanya katılım başvurunuzu aldık. Önerdiğiniz satıcı ile iletişime geçtikten sonra kampanya koşullarına uygunluğu hakkında sizi bilgilendireceğiz.',
    ok: 'TAMAM',
  },
};
